import React from "react";

function Header() {
  return (
    <div style={{ paddingBottom: "10px", paddingTop: "10px" }}>
      <img
        style={{ width: "5em", height: "5em", paddingBottom: "10px" }}
        src="https://www.svgrepo.com/show/224114/feeder.svg"
        alt="bottle"
      />
      <h1>Baby Name Picker</h1>
    </div>
  );
}

export default Header;
